import React, { useEffect } from "react";
import { ReactComponent as QuizIcon } from "../../assets/images/quiz.svg";
import { ReactComponent as PDFIcon } from "../../assets/images/test.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/video.svg";
import { ReactComponent as GreenTick } from "../../assets/images/greenTick.svg";
import { ReactComponent as TextIcon } from "../../assets/images/textIcon.svg";
import DescriptionIcon from "@material-ui/icons/Description";
import "./SelfLearning.scss";
import { Box, useMediaQuery } from '@material-ui/core';
import { selfLearningVideoUrl } from "examsbook-react-sdk/actions/selfLearningVideoUrl";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "examsbook-react-sdk/custom-hooks";
import { ColorsConstant } from "../../constants/colorConstant";
import { setDataId, setSectionId } from "examsbook-react-sdk/actions/getSelfLearningAction";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import { useTheme } from "../../constants/themeProvider";
import { CircularProgressbar } from "react-circular-progressbar";
import PropTypes from 'prop-types';

export default function SelfLearningSubmenu(props) {
  let subMenuName = props;
  let iconName = props?.data?.refModel;
  const dispatch = useDispatch();
  const classes = useStyles(styles)();
  const sectionIdFromRedux = useSelector(state => state.selfLearningReducers.sectionId);
  const dataIdFromRedux = useSelector(state => state.selfLearningReducers.dataId);

  useEffect(() => {
    if (props?.selectedSubmenu && (props?.selectedSubmenu!==null || props?.selectedSubmenu!==undefined)) {
      dispatch(setDataId(props?.selectedSubmenu));
    }
  }, [dispatch, props?.selectedSubmenu, dataIdFromRedux]);

  useEffect(() => {
    if (props?.sectionId && (props?.sectionId!==null || props?.sectionId!==undefined)) {
      dispatch(setSectionId(props?.sectionId));
    }
  }, [props?.sectionId, dispatch, sectionIdFromRedux]);

  const { sectionIndex, index, handleUpdateCourseProgress, setCurrentSectionIndex, setCurrentDataIndex, openPdfViewer  } = props;

  const handleGreenTick = (data) => {
    if (data?.isRead && data?.percent >= 99) {
      return <GreenTick/>;
    }
     else {
      return (
        <Box>
          <LinearProgressWithLabel value={data?.percent} width={20}/>
        </Box>
      );
    }
  };

  const handleOnClick = (id) => {
    setCurrentDataIndex(index);
    setCurrentSectionIndex(sectionIndex);
    props.setSelectedSubmenu(id);
    dispatch(setSectionId(props?.sectionId));
    dispatch(setDataId(props?.data?._id));
    if (props?.data?.refModel === "RecordedVideo") {
      dispatch(selfLearningVideoUrl(subMenuName));
      props.setSectionChanged(false);
    } else if (props?.data?.refModel === "TextNotes") {
      dispatch(selfLearningVideoUrl(subMenuName));
      let data = {
        sectionId: props?.sectionId,
        dataId: props?.data?._id,
        percent: 100,
        courseId: props?.courseId ? props?.courseId : props?.section?.data?.courseId?._id,
        isRead: true
      }
      handleUpdateCourseProgress(data)
    } else if (props?.data?.refModel === "PdfNotes") {
      let data = {
        sectionId: props?.sectionId,
        dataId: props?.data?._id,
        percent: 100,
        courseId: props?.courseId ? props?.courseId : props?.section?.data?.courseId?._id,
        isRead: true
      }
      handleUpdateCourseProgress(data)
      props.onPdfOpen(!props?.pdfOpen);
      openPdfViewer(props?.data?.contentData?.featured);
    }
    if (props.onSubmenuClick) {
      props.onSubmenuClick(props);
    }
  };

  function LinearProgressWithLabel({ value = 0 }) {
    const theme = useTheme();
    const muiTheme = useMuiTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
    const overallProgress = Math.round(value);

    return (
      <Box width="100%" display="flex" alignItems="center" justifyContent="center" sx={{ gap: isMobile ? "6px" : '10px' }}>
        {overallProgress <= 99 && (
          <>
            <Box width={isMobile ? "18px" : "20px"}>
              <CircularProgressbar value={overallProgress} styles={{ path: { stroke: isMobile ? theme?.primaryFontText :theme?.primaryColor, strokeWidth: '10px' } }}/>
            </Box>
          </>
        )}
      </Box>
    );
  }

  LinearProgressWithLabel.propTypes = {
      value: PropTypes.number.isRequired,
  };

  return (
    <>
      <div
        id={props?.index}
        className="outerBox2 submenu isHover"
        style={{
          backgroundColor:
            props?.selectedSubmenu === props?.data?._id
              ? ColorsConstant.backgroundHighlight
              : "transparent",
        }}
        onClick={() => handleOnClick(props?.data?._id)}
      >
        <div className="innerBox">
          <div className="submenu-content">
            <div className="submenu-image">
              {iconName === "Quiz" && <QuizIcon />}
              {iconName === "RecordedVideo" && <VideoIcon />}
              {iconName === "PdfNotes" && <PDFIcon />}
              {iconName === "TextNotes" && <TextIcon />}
              {iconName === "Questions" && <QuizIcon />}
              {iconName === "Assignments" && <DescriptionIcon style={{ color: 'black', opacity: 0.54 }} />}
            </div>
            <p className={classes.genustext}>{props?.data?.name}</p>
          </div>
          <Box display="flex">{handleGreenTick(props?.data)}</Box>
        </div>
      </div>
    </>
  );
}

const styles = {
  genustext: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0px',
    gap: '10px',
    width: '-webkit-fill-available',
    fontSize: '14px',
    color: ColorsConstant.descriptionColor,
    fontWeight: 400,
    "@media (max-width: 767px)": {
      width: "auto",
    },
  },
};
